<template>
	<div class="invoice-view">
		<v-card flat v-if="isLoading">
			<v-card-text>
				<v-progress-linear :indeterminate="true"></v-progress-linear>
			</v-card-text>
		</v-card>
		<div v-else>
			<v-card outlined>
				<ReportViewBar :title="reportName()" />
				<v-container fluid grid-list-lg>
					<v-layout row wrap class="no-print">
						<v-flex xs12 md4>
							<div>Select Month</div>
							<v-autocomplete dense item-text="name" hide-details :items="dates" clearable v-model="selectedDate"
								return-object label="Select Date" outlined>
								<template slot="item" slot-scope="{ item }">
									<span>{{ $moment(item.date).format('MMMM YY') }}</span>
									<v-spacer></v-spacer>
								</template>
							</v-autocomplete>
						</v-flex>
						<v-flex xs12 md4>
							<div>Select Department</div>
							<v-combobox v-model="selectedClasses" :items="classesCombo" label="Class" item-text="name" item-value="id"
								multiple outlined dense></v-combobox>
						</v-flex>
						<v-flex xs12 md4>
							<div>Select Class Room</div>
							<v-combobox v-model="selectedClassRooms" :items="getClassRoomsCombo" label="Class Room" item-text="name"
								item-value="id" multiple outlined dense></v-combobox>
						</v-flex>

						<v-spacer></v-spacer>
					</v-layout>
					<table class="center">
						<tbody class="report-container">
							<v-card-text class="pt-0">
								<tr></tr>
							</v-card-text>
						</tbody>
					</table>
				</v-container>


				<v-card flat outlined>
					<v-container v-if="dataLoading" fill-height fluid>
						<v-row align="center" justify="center">
							<v-col align="center" justify="center">
								<v-progress-circular :indeterminate="true"></v-progress-circular>
							</v-col>
						</v-row>
					</v-container>
					<v-simple-table v-else>
						<template v-slot:default>
							<thead>
								<tr>
									<th></th>
									<th v-for="index in daysInMonth" class="text-left font-weight-bold" :key="index">
										{{ index }}
									</th>
								</tr>
							</thead>
							<tbody v-if="getAttendanceSheet">
								<tr v-for="value in getAttendanceSheet" :key="value.id">
									<td class="text-left">
										<div class="font-weight-bold">{{ value.classRoomName }}</div>
										<div>{{ value.classTeacherName }}</div>

									</td>
									<td :class="{ todayColor: isToday(attendance) }" v-for="(attendance, index2) in value.Attendance"
										:key="index2">
										<!-- <v-tooltip top>
											<div>
												<span>Class Room: {{value.classRoomName}}</span>
												<v-spacer></v-spacer>
												<span>Date: {{ $moment(attendance.attendanceDate).format('LL LT') }}</span>
												<v-spacer></v-spacer>
												<span>Teacher: {{value.classTeacherName}}</span>
											</div>

											<template v-slot:activator="{ on, attrs }"> -->
										<!-- <div v-if="">{{$moment(attendance.attendanceDate).format('MM/DD/YYYY')}}</div> -->

										<v-icon color="green" @click="viewAttendance(attendance)" dark v-if="attendance.attendanceTaken">
											mdi-check-circle
										</v-icon>
										<div class="text-center" v-else>
											<v-avatar size="10" color="red">

											</v-avatar>
										</div>

										<!-- <v-icon v-else color="red" dark>
											mdi-close-circle
										</v-icon> -->
										<!-- </template> -->
										<!-- </v-tooltip> -->
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-card>
			</v-card>
		</div>
		<!-- <v-dialog v-model="openAttendanceDialog" width="500">

			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					Privacy Policy
				</v-card-title>

				<v-card-text v-if="selectedAttendance">
					<v-list>
						<v-list-item :key="student.id" v-for="student in selectedAttendance.AttendanceDetails">
							<v-list-item-content>
								<v-list-item-title>{{ student.Student.fullName }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="openAttendanceDialog = false">
						Close
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> -->
		<createAtt :openDialog="openAttendanceDialog" @close="attendanceDialogClose" v-if="openAttendanceDialog"
			:selectedAttendance="selectedAttendance" />
	</div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
// import reportViewService from "@/modules/ReportView/service";
import attService from '@/modules/TeacherModules/Attendance/service.js'
import classRoomService from "@/modules/ClassRoom/service.js";
import classService from "@/modules/Classes/service.js";
import { mapGetters, mapActions } from "vuex";
import createAtt from '@/modules/ReportView/components/attendance/Create.vue'

export default {
	data() {
		return {
			selectedAttendance: null,
			openAttendanceDialog: false,
			daysInMonth: 31,
			selectedDate: null,
			dates: [],
			isLoading: false,
			classRooms: [],
			attendances: [],
			attendanceSheet: {},
			classRoomsCombo: [],
			selectedClassRooms: [],
			filteredClassRooms: [],
			classesCombo: [],
			selectedClasses: [],
			filteredClasses: [],
			dataLoading: false,
		};
	},
	computed: {
		...mapGetters("global", ["currentBusiness"]),
		getAttendanceSheet() {
			// console.log('this.attendanceSheet', this.attendanceSheet)
			return this.attendanceSheet;
		},
		getClassRoomsCombo() {
			return this.classRoomsCombo
		}
	},
	created() {
		this.setMonths();
		// if (!this.currentBusiness) this.initUser();
		this.getClassRoomsForCombo();
		this.getClassesForCombo();
		this.getClasses();
	},
	watch: {
		async selectedClasses(val) {
			console.log('val is :asdfasdf', val)
			this.filteredClasses = []
			if (val && val.length > 0) {
				Promise.all(val.map(item => {
					this.filteredClasses.push(item.id)
				}))
					.then(async () => {
						await this.getClassRoomsForCombo();
						return this.loadData()
					})
			} else {
				await this.getClassRoomsForCombo();
				return this.loadData()
			}
		},
		selectedClassRooms(val) {
			console.log('val is :', val)
			this.filteredClassRooms = []
			if (val && val.length > 0) {
				Promise.all(val.map(item => {
					this.filteredClassRooms.push(item.id)
				}))
					.then(() => {
						return this.loadData()
					})
			} else {
				return this.loadData()
			}
		},
		// openAttendanceDialog(val) {
		// 	if (val) {
		// 		console.log('viewAttendance')
		// 	}
		// },
		selectedDate(val) {
			if (val) {
				this.daysInMonth = this.$moment(val.date).daysInMonth();
				this.loadData(val);
			}
		}
	},
	components: { ReportViewBar, createAtt },
	methods: {
		...mapActions("global", ["initUser", "initBusiness"]),
		isToday(attendance) {
			let value = false
			if (attendance.attendanceDate && this.$moment(attendance.attendanceDate).format('DD') === this.$moment().format('DD')) {
				value = true
			}
			// console.log('test', val)
			return value
		},
		getAttendanceById(id) {
			return attService.getById(id)
				.then(response => {
					this.selectedAttendance = response.data;
					console.log('selectedAttendance :', this.selectedAttendance);
					return response.data
				})
		},
		viewAttendance(val) {
			console.log('viewAttendance', val)
			this.getAttendanceById(val.id)
			this.openAttendanceDialog = !this.openAttendanceDialog
		},
		attendanceDialogClose() {
			this.openAttendanceDialog = !this.openAttendanceDialog
			this.selectedAttendance = null
		},
		setMonths() {
			var startDate = this.$moment();
			var endDate = this.$moment(startDate).subtract(12, 'M');
			var month = this.$moment(startDate); //clone the startDate
			while (month > endDate) {
				this.dates.push({
					date: month.format('YYYY-MM-DD'),
					name: this.$moment(month).format('MMMM YY')
				});
				month.subtract(1, "month");
			}
			// console.log(this.dates);
			this.selectedDate = this.dates[0]
			this.loadData();
		},
		reportName() {
			return 'Attendance Report'
		},
		getClasses() {

			return classRoomService.getAll({
				lite: true,
				filteredClassRooms: this.filteredClassRooms,
				filteredClasses: this.filteredClasses
			})
				.then(response => {
					this.classRooms = response.data;
					console.log('respinse is :', response);
					return response.data
				})
		},
		getClassRoomsForCombo() {
			return classRoomService.getAll({
				lite: true,
				filteredClasses: this.filteredClasses
			})
				.then(response => {
					this.filteredClassRooms = [];
					this.selectedClassRooms = [];
					this.classRoomsCombo = response.data;
					console.log('respinse is :', response);
					return response.data
				})
		},
		getClassesForCombo() {

			return classService.getAll({
				lite: true,
			})
				.then(response => {
					this.classesCombo = response.data;
					console.log('classesCombo is :', response);
					return response.data
				})
		},
		getAttendance() {
			return attService.getAtttendanceForReport({
				start: (this.selectedDate) ? this.selectedDate.date : null,
				filteredClassRooms: this.filteredClassRooms,
				filteredClasses: this.filteredClasses
			})
				.then(response => {
					this.attendances = response.data;
					// console.log('respinse is :', response);
					return response.data
				})

		},
		async loadData() {

			this.dataLoading = true
			await this.getClasses();
			await this.getAttendance(); // getting attendance for the given month
			this.setAttendance(); // setting up attendance data
			this.dataLoading = false
		},
		async setAttendance() {
			let daysInMonth = this.$moment(this.selectedDate.date).daysInMonth(); // getting days in month
			let attendanceSheet = {}
			// looping through every class
			this.classRooms.map((classRoom) => {

				// setting up object
				if (attendanceSheet[`${classRoom.id}`]) {
					if (!attendanceSheet[`${classRoom.id}`].Attendance) {
						attendanceSheet[`${classRoom.id}`].Attendance = [];
					}
				} else {
					attendanceSheet[`${classRoom.id}`] = {
						id: classRoom.id,
						classTeacherName: (classRoom.ClassRoomTeachers[0]
							&& classRoom.ClassRoomTeachers[0].Teacher
						) ? classRoom.ClassRoomTeachers[0].Teacher.name : 'Not Assigned',
						classRoomName: classRoom.name,
						Attendance: []
					};
				}
				// assigning every index as no attendance
				for (let i = 0; i < daysInMonth; i++) {
					attendanceSheet[`${classRoom.id}`].Attendance[i] = {
						date: i + 1,
						attendanceTaken: false
					};
				}
				// addding those having attendance for the given date
				this.attendances.map(attendance => {
					// console.log('attendance', attendance)
					const dateObject = new Date(attendance.attendanceDate);
					const day = dateObject.getDate();
					if (attendance.ClassRoomId == classRoom.id && attendanceSheet[`${attendance.ClassRoomId}`]) {
						attendanceSheet[`${attendance.ClassRoomId}`].Attendance[day - 1] = {
							date: day,
							attendanceTaken: true,
							attendanceDate: attendance.attendanceDate,
							id: attendance.id
						};
						// console.log('attendance', attendance)
					}
				})
			})
			// doing this in order to make attendanceSheet reactive by assigning a new array to it
			return this.attendanceSheet = attendanceSheet;

		}
	},
};
</script>

<style scoped>
@media print {
	container {
		height: 100%;
		margin: 0 !important;
		padding: 0 !important;
		overflow: hidden;
	}

	.no-print {
		display: none;
	}

	.detailBox {
		overflow: visible;
		height: 100%;
	}

	* {
		background: 0 0 !important;
		color: #000 !important;
		box-shadow: none !important;
		text-shadow: none !important;
	}
}

.dot {
	height: 3px;
	width: 3px;
	border-radius: 90%;
}

.paidImg {
	position: absolute;
	left: 40%;
	top: 10%;
}

.signature {
	margin-top: 100px;
}

.center {
	background-color: white;
	margin: auto;
	width: 100%;
}

.todayColor {
	background-color: #E0E0E0;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
